const _ = require('lodash')

export const formatClassificationsToCsv = (allActiveClassificationRecords) => {
  const formattedClassifications = formatClassifications(
    allActiveClassificationRecords
  )
  const sortedClassificationRecords = _.orderBy(
    formattedClassifications,
    ['mcpSku'],
    ['asc']
  )

  const records = []
  sortedClassificationRecords.forEach((classification) => {
    const { mcpSku, coo } = classification
    const htsCodeMapping = classification.htsCodes
    const attribute = classification.attribute
    Object.keys(htsCodeMapping).forEach((htsCode) => {
      let preferentialOrigins = [],
        nonPreferentialOrigins = [],
        countriesOfClassification = []
      for (const country of htsCodeMapping[htsCode]) {
        if (country.preferentialOrigin === true) {
          preferentialOrigins.push(country.country)
        } else {
          nonPreferentialOrigins.push(country.country)
        }
        countriesOfClassification.push(country.country)
      }
      records.push({
        'Fulfillment SKU (ie. CIM-ZGD74VRM)': mcpSku,
        'Country of Origin (2 letter country code)': coo,
        'Customs Description': classification.description || '',
        'Countries of Classification (2 letter country code; separated by semicolon)':
          countriesOfClassification.join(';'),
        'HTS Code': htsCode || '',
        'Countries that are Preferential Origin (separated by semicolon)':
          preferentialOrigins.join(';'),
        'Countries that are not Preferential Origin (separated by semicolon)':
          nonPreferentialOrigins.join(';'),
        'Attribute (ie. Substrate:GlossyAluminium)': attribute || ''
      })
    })
  })

  return records
}

export const formatClassifications = (classifications) => {
  const formattedClassifications = []
  classifications.forEach((classification) => {
    const attribute = classification.attributes
      ? Object.keys(classification.attributes)
          .map((key) => {
            return key + ':' + classification.attributes[key]
          })
          .join(';')
      : undefined
    const htsCodes = generateHtsCodeMapping(classification)
    formattedClassifications.push({
      mcpSku: classification.mcpSku,
      coo: classification.countryOfOrigin,
      description: classification?.customsDescription,
      attribute,
      htsCodes
    })
  })

  return formattedClassifications
}

export const generateHtsCodeMapping = (classification) => {
  const htsCodes = {}
  const countryClassifications = classification.countryClassifications
  if (countryClassifications) {
    Object.keys(countryClassifications).forEach((key) => {
      const { htsCode, preferentialOrigin } = countryClassifications[key]
      if (htsCodes[htsCode]) {
        htsCodes[htsCode].push({ country: key, preferentialOrigin })
      } else {
        htsCodes[htsCode] = [{ country: key, preferentialOrigin }]
      }
    })
  }
  return htsCodes
}
